module.exports = __webpack_public_path__ + "img/SE.e08481c0.svg";